// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".left{border-radius:6px 0 0 6px;margin-right:1px}.left.secondary-theme{margin-right:0}.mp-sharing-status-button-container{align-items:center;display:flex;position:relative}.fully-rounded{border-radius:6px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
